import { render } from "./TopicNavbar.vue?vue&type=template&id=383ada5c&scoped=true"
import script from "./TopicNavbar.vue?vue&type=script&lang=js"
export * from "./TopicNavbar.vue?vue&type=script&lang=js"

import "./TopicNavbar.vue?vue&type=style&index=0&id=383ada5c&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-383ada5c"

export default script